import { IIrpAddEditRequest } from '../../../../model/scp/irp/request/irp-add-edit-request';
import { IIrpItemAddEditRequest } from '../../../../model/scp/irp/request/irp-item-add-edit-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';
import { isEmptyAmount } from '../../shared/scp-utils';

export type IrpField = 'clientId' | 'typeCallingInstrumentId' | 'modalityId' | 'disputeModeId' | 'legalSupportId' | 'codManagingUnit'
    | 'yearIrp' | 'numberIrp' | 'finalInterestManifestationDate' | 'title' | 'objectIrp' | 'urlSystemOrigin' | 'documentTypeId' | 'file';

// Na inclusão, título e documento são enviados junto com a IRP; na edição não fazem parte do formulário
export function validateIrp(request: IIrpAddEditRequest, options: { isEdit: boolean; hasFile: boolean }): ValidationErrors<IrpField> {
    const errors: ValidationErrors<IrpField> = {};
    if (isEmptyId(request.clientId)) errors.clientId = 'Entidade é obrigatória';
    if (isEmptyId(request.typeCallingInstrumentId)) errors.typeCallingInstrumentId = 'Instrumento convocatório é obrigatório';
    if (isEmptyId(request.modalityId)) errors.modalityId = 'Modalidade é obrigatória';
    if (isEmptyId(request.disputeModeId)) errors.disputeModeId = 'Modo de disputa é obrigatório';
    if (isEmptyId(request.legalSupportId)) errors.legalSupportId = 'Amparo legal é obrigatório';
    if (isBlank(request.codManagingUnit)) errors.codManagingUnit = 'Unidade gerenciadora é obrigatória';
    if (isEmptyId(request.yearIrp)) errors.yearIrp = 'Exercício é obrigatório';
    if (isBlank(request.numberIrp)) errors.numberIrp = 'Número é obrigatório';
    if (!request.finalInterestManifestationDate) errors.finalInterestManifestationDate = 'Data final para manifestação é obrigatória';
    if (isBlank(request.objectIrp)) errors.objectIrp = 'Objeto é obrigatório';
    if (isBlank(request.urlSystemOrigin)) errors.urlSystemOrigin = 'URL do sistema de origem é obrigatória';
    if (!options.isEdit) {
        if (isBlank(request.title)) errors.title = 'Título é obrigatório';
        if (isEmptyId(request.documentTypeId)) errors.documentTypeId = 'Tipo de documento é obrigatório';
        if (!options.hasFile) errors.file = 'Arquivo é obrigatório';
    }
    return errors;
}

export type IrpItemField = 'typeItem' | 'categoryItemId' | 'criterionJudgmentId' | 'unitSupply' | 'unitValueEstimated' | 'description' | 'justification';

// Itens já enviados ao PNCP só podem ser retificados (descrição, unidade, valor e complemento) com justificativa
export function validateIrpItem(item: IIrpItemAddEditRequest, isRetification: boolean): ValidationErrors<IrpItemField> {
    const errors: ValidationErrors<IrpItemField> = {};
    if (isBlank(item.unitSupply)) errors.unitSupply = 'Unidade de fornecimento é obrigatória';
    if (isEmptyAmount(item.unitValueEstimated)) errors.unitValueEstimated = 'Valor unitário estimado é obrigatório';
    if (isBlank(item.description)) errors.description = 'Descrição é obrigatória';
    if (isRetification) {
        if (isBlank(item.justification)) errors.justification = 'Justificativa é obrigatória';
        return errors;
    }
    if (isEmptyId(item.typeItem)) errors.typeItem = 'Tipo é obrigatório';
    if (isEmptyId(item.categoryItemId)) errors.categoryItemId = 'Categoria é obrigatória';
    if (isEmptyId(item.criterionJudgmentId)) errors.criterionJudgmentId = 'Critério de julgamento é obrigatório';
    return errors;
}
